<template>
  <div class="bravado-right-navigation">
    <div class="bravado-right-navigation__container">
      <div class="bravado-right-navigation__content-wrapper">
        <div class="bravado-right-navigation__content">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@nuxtjs/composition-api';
import JobsHiringsCountMixin from '@/components/common/BravadoRightNavigation/JobsHiringsCountMixin';
import WarRoomUnreadPostsCountMixin from '@/components/common/BravadoRightNavigation/WarRoomUnreadPostsCountMixin';
import type { IMenuItem } from '@/components/common/BravadoRightNavigation/constants';
import { getMenuItems } from '@/components/common/BravadoRightNavigation/constants';
import type { CurrentUser } from '@/types';

export default defineComponent({
  name: 'BravadoRightNavigation',
  mixins: [JobsHiringsCountMixin, WarRoomUnreadPostsCountMixin],
  props: {
    hideMenu: {
      type: Boolean,
      default: false,
    },
    wide: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    visibleItems(): IMenuItem[] {
      return getMenuItems({
        user: this.$auth.user as CurrentUser,
        unreadPostsMessage: this.unreadPostsMessage,
        hiringCount: this.hiringCount,
      });
    },
  },
  methods: {
    onClick(item: IMenuItem): void {
      this.$analytics.logEvent('war-room__sidebar-navigation__click', {
        to: item.label.replaceAll(' ', '-').toLowerCase(),
      });
    },
  },
});
</script>

<style lang="scss" scoped>
.bravado-right-navigation {
  display: flex;
  width: 100%;
  justify-content: center;
  min-height: calc(100vh - 56px);
  background: var(--theme-color-background);

  &__container {
    margin-top: 16px;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    overflow: visible;
    width: 100%;

    @include mq('sm') {
      margin-top: 0;
      overflow: visible;
    }

    @include mq('lg') {
      padding: 24px;
    }
  }

  &__content-wrapper {
    flex-grow: 1;
    flex-shrink: 0;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding: 0 1em;
    max-width: 100%;
    margin: 0 auto;
    width: 100%;
    margin-bottom: 24px;

    @include mq('sm') {
      padding: 24px 30px calc(24px + 72px);
    }

    @include mq('lg') {
      max-width: 1280px;
      padding: 0 2em;
    }
  }

  &__content {
    width: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
}
</style>
